<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <tracking-progress :transDataSet="transDate"></tracking-progress>
      <div class="join container">
        <div class="notification">
          <span class="imgWrap"><img src="../../assets/images/thanq_logo.png" /></span>
          <p>회원정보 변경이 완료 되었어요!</p>
          <p>땡큐와 함께 쉽고 편리하게 건강을 관리하세요!</p>
        </div>
      </div>
      <div class="btnWrap visible">
        <button class="" type="button" @click="nextMain()">확인</button>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '../../components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import TrackingProgress from '../../components/TrackingProgress'
import { mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        nextLink: '',
        closeType: 'close'
      },
      transDate: {
        headerName: '회원정보변경 완료',
        progressNum: '100%',
        chapterNum: 3,
        prevUrl: '/'
      },
      underAgeChecked: false,
      overAgeChecked: false,
      buttonUp: false,
      setCount: false
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    TrackingProgress,
    AddPopup
  },
  computed: {
    ...mapState([
      'checkPopup'
    ]),
    ...mapGetters('referrer', [
      'getReferrer'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    nextMain () {
      this.$router.push('/')
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  created () {
    /* url 직접 접근 막기 */
    if (this.getReferrer.includes('modifyUser/modify') !== true) {
      this.SET_POPUP(true)
      this.popupSet.content = '잘못된 접근입니다.'
      this.popupSet.count = 'another'
      this.popupSet.nextLink = '/'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = '/'
    }
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_POPUP(false)
    this.SET_REFERRER('')
  }
}
</script>

<style lang="scss" scoped>
</style>
